<template>
  <b-sidebar
    :id="local_licence.id ? 'sidebar-edit-' + local_licence.id : 'sidebar-new'"
    :title="local_licence.title ? local_licence.title : 'Nueva licencia'"
    sidebar-class="bb-offcanvas-panel"
    bg-variant="white"
    right
    backdrop-variant="dark"
    backdrop
    shadow
  >
    <template>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.title.$error }"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-title' + local_licence.id"
          >Nombre de la licencia</label
        >
        <input
          type="text"
          :id="'licence-title' + local_licence.id"
          v-model="local_licence.title"
          maxlength="255"
          placeholder="Nombre de la licencia"
        />
      </div>
      <div class="error" v-if="$v.local_licence.title.$error">
        Debes escribir un nombre para la licencia
      </div>
      <div class="row form-row">
        <label :for="'licence-key' + local_licence.id">Clave</label>
        <input
          type="text"
          :id="'licence-key' + local_licence.id"
          v-model="local_licence.key"
          maxlength="255"
          :disabled="local_licence.id"
        />
      </div>
      <div class="row form-row">
        <label :for="'licence-secret' + local_licence.id">Secreto</label>
        <input
          type="text"
          :id="'licence-secret' + local_licence.id"
          v-model="local_licence.secret"
          maxlength="255"
          :disabled="local_licence.id"
        />
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.font.$error }"
      >
        <label class="column col-sm-12 ng-scope form__label"
          ><span class="mandatory-mark" aria-hidden="true">*</span>Fuente para
          texto</label
        >
        <b-form-select
          :id="'licence-font' + local_licence.id"
          :options="font_options"
          v-model="local_licence.font"
        ></b-form-select>
      </div>
      <div class="error" v-if="!$v.local_licence.font.required">
        Debes seleccionar la fuente para los textos
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.primaryColor.$error }"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-main-color' + local_licence.id"
          >Color principal</label
        >
        <input
          type="color"
          :id="'licence-main-color' + local_licence.id"
          v-model="local_licence.primaryColor"
          placeholder="Color en hexadecimal"
        />
      </div>
      <div class="error" v-if="$v.local_licence.primaryColor.$error">
        Debes introducir un color principal en hexadecimal
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.secondaryColor.$error }"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-secondary-color' + local_licence.id"
          >Color secundario</label
        >
        <input
          type="color"
          :id="'licence-secondary-color' + local_licence.id"
          v-model="local_licence.secondaryColor"
          placeholder="Color en hexadecimal"
        />
      </div>
      <div class="error" v-if="$v.local_licence.secondaryColor.$error">
        Debes introducir un color secundario en hexadecimal
      </div>
      <fieldset>
        <legend>
          <h3 class="form-label">Estado de activación</h3>
        </legend>
        <div class="checkbox-wrap list">
          <input
            :id="'enable-licence-' + local_licence.id"
            type="checkbox"
            v-model="local_licence.enabled"
          />
          <label :for="'enable-licence-' + local_licence.id"
            >Permitir la utilización de la licencia (activada)</label
          >
        </div>
      </fieldset>
      <div class="row form-row user-role-select">
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'consumer-licence-' + local_licence.id"
          >Tipo de plataforma</label
        >
        <select
          :id="'consumer-licence-' + local_licence.id"
          v-model="local_licence.toolConsumer"
        >
          <option label="Canvas" value="1">Canvas</option>
          <option label="Sakai" value="2">Sakai</option>
          <option label="LMS10/30 (Straining)" value="3">
            LMS10/30 (Straining)
          </option>
          <option label="Moodle" value="4">Moodle</option>
        </select>
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.domain.$error }"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-domain' + local_licence.id"
          >URL base de la plataforma</label
        >
        <input
          type="text"
          :id="'licence-domain' + local_licence.id"
          v-model="local_licence.domain"
          maxlength="255"
        />
      </div>
      <div class="error" v-if="$v.local_licence.domain.$error">
        La URL de la plataforma es obligatoria y debe ser válida
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.accessToken.$error }"
        v-if="
          local_licence.toolConsumer.toString() === '1' ||
          local_licence.toolConsumer.toString() === '3' ||
          local_licence.toolConsumer.toString() === '4'
        "
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-token' + local_licence.id"
          >API Token (administrador)</label
        >
        <input
          type="text"
          :id="'licence-token' + local_licence.id"
          v-model="local_licence.accessToken"
          maxlength="255"
        />
      </div>
      <div class="error" v-if="$v.local_licence.accessToken.$error">
        El token es obligatorio
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.userName.$error }"
        v-if="local_licence.toolConsumer.toString() === '2'"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-username' + local_licence.id"
          >Nombre de usuario API (administrador)</label
        >
        <input
          type="text"
          :id="'licence-username' + local_licence.id"
          v-model="local_licence.userName"
          maxlength="255"
        />
      </div>
      <div class="error" v-if="$v.local_licence.userName.$error">
        El nombre de usuario es obligatorio
      </div>
      <div
        class="row form-row"
        :class="{ 'form-group--error': $v.local_licence.password.$error }"
        v-if="local_licence.toolConsumer.toString() === '2'"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-password' + local_licence.id"
          >Clave usuario API</label
        >
        <input
          type="text"
          :id="'licence-password' + local_licence.id"
          v-model="local_licence.password"
          maxlength="255"
        />
      </div>
      <div class="error" v-if="$v.local_licence.password.$error">
        La clave de usuario es obligatoria
      </div>
      <div
        class="row form-row"
        :class="{
          'form-group--error': $v.local_licence.strainingPlatformId.$error,
        }"
        v-if="local_licence.toolConsumer.toString() === '3'"
      >
        <span class="mandatory-mark" aria-hidden="true">*</span
        ><label :for="'licence-password' + local_licence.id"
          >Id de plataforma</label
        >
        <input
          type="text"
          :id="'licence-password' + local_licence.id"
          v-model="local_licence.strainingPlatformId"
          maxlength="255"
        />
      </div>
      <div class="error" v-if="$v.local_licence.strainingPlatformId.$error">
        El Id de la plataforma es obligatorio
      </div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons">
          <div class="col-sm-4">
            <button class="button save-button" @click="updateLicence">
              Guardar
            </button>
          </div>
          <div class="col-sm-4">
            <button class="button secondary cancel-button" @click="hide">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import ServiceLicences from "@/service/licences.js";
import CloseIcon from "vue-material-design-icons/Close.vue";
import LocationEnterIcon from "vue-material-design-icons/LocationEnter.vue";
import utilitiesMixin from "../../../mixins/utilitiesMixin";
import { required, requiredIf, url, helpers } from "vuelidate/lib/validators";
const hexColorValidator = helpers.regex("hexColor", /^#[0-9A-F]{6}$/i);

export default {
  name: "EditLicenceSidebar",
  // eslint-disable-next-line vue/no-unused-components
  components: { CloseIcon, LocationEnterIcon },
  mixins: [utilitiesMixin],
  props: ["licence", "ac_instances", "hide"],
  mounted() {
    this.$moment.locale("es");
  },
  created() {
    this.local_licence = this._.cloneDeep(this.licence);
    if (!this.local_licence.id) {
      this.local_licence.key = this.randomString(10);
      this.local_licence.secret = this.randomString(32);
    }
  },
  data() {
    return {
      loading: false,
      local_licence: {
        id: "",
        title: "",
        domain: "",
        enabled: true,
        key: null,
        secret: null,
        toolConsumer: 1,
        accessToken: "",
        acInstanceId: null,
        userName: "",
        password: "",
        strainingPlatformId: "",
        primaryColor: "",
        secondaryColor: "",
        font: null,
      },
      default_null: null,
      font_options: this.fontOptions(),
    };
  },
  validations: {
    local_licence: {
      title: {
        required,
      },
      domain: {
        required,
        url,
      },
      accessToken: {
        required: requiredIf(function () {
          return (
            this.local_licence.toolConsumer.toString() === "1" ||
            this.local_licence.toolConsumer.toString() === "3" ||
            this.local_licence.toolConsumer.toString() === "4"
          );
        }),
      },
      userName: {
        required: requiredIf(function () {
          return this.local_licence.toolConsumer.toString() === "2";
        }),
      },
      password: {
        required: requiredIf(function () {
          return this.local_licence.toolConsumer.toString() === "2";
        }),
      },
      strainingPlatformId: {
        required: requiredIf(function () {
          return this.local_licence.toolConsumer.toString() === "3";
        }),
      },
      primaryColor: {
        required,
        hexColorValidator,
      },
      secondaryColor: {
        required,
        hexColorValidator,
      },
      font: {
        required,
      },
    },
  },
  methods: {
    updateLicence() {
      let vueComponent = this;

      // CMM: Validación previa al envío de formulario
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      // CMM: Se distingue un alta de una actualización
      if (this.local_licence.id) {
        ServiceLicences.putLicences(
          this.local_licence.id,
          this.local_licence
        ).then((response) => {
          if (response && response.status === 200) {
            vueComponent.$noty.success(
              "La licencia se ha actualizado correctamente",
              {
                timeout: 3000,
                progressBar: true,
              }
            );
            vueComponent.$root.$emit(
              "bv::toggle::collapse",
              "sidebar-edit-" + vueComponent.local_licence.id
            );
            vueComponent.$emit("refresh");
          } else {
            vueComponent.$noty.error(
              "No se ha podido actualizar la licencia. Compruebe los datos de configuración.",
              {
                timeout: 3000,
                progressBar: true,
              }
            );
          }
        });
      } else {
        ServiceLicences.postLicences(this.local_licence).then((response) => {
          if (response && response.status === 200) {
            vueComponent.$noty.success(
              "La licencia se ha registrado correctamente",
              {
                timeout: 3000,
                progressBar: true,
              }
            );
            vueComponent.$root.$emit("bv::toggle::collapse", "sidebar-new");
            vueComponent.$emit("refresh");
          } else {
            vueComponent.$noty.error(
              "No se ha podido registrar la licencia. Compruebe los datos de configuración.",
              {
                timeout: 3000,
                progressBar: true,
              }
            );
          }
        });
      }
    },
  },
};
</script>
